import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

// 重写push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

//导入路由组件
import Home from "@/views/home";
import Aurora from "@/views/aurora";
import Tanix from "@/views/tanix";
import x96Q from "@/views/x96q";
import About from "@/views/about";
import AuroraElite from "@/views/elite";
import videoGuidance from "@/views/videoGuidance";
import remote from "@/views/downloadRemote";
import mcstore from "@/views/downloadMcstore";

export default new VueRouter({
  routes: [
    {
      path: "/index",
      name: "index",
      component: Home,
    },
	{
	  path: "/about",
	  name: "about",
	  component: About,
	},
    {
      path: "/auroraw2",
      name: "aurora",
      component: Aurora,
    },
    {
      path: "/tanixw2",
      name: "tanixw2",
      component: Tanix,
    },
    {
      path: "/x96q",
      name: "x96q",
      component: x96Q,
    },
	{
	  path: "/auroraElite",
	  name: "auroraElite",
	  component: AuroraElite,
	},
    {
      path: "/videoGuidance",
      name: "videoGuidance",
      component: videoGuidance,
    },
    {
      path: "/remote",
      name: "remote",
      component: remote,
    },
	{
	  path: "/mcstore",
	  name: "mcstore",
	  component: mcstore,
	},
    {
      path: "/",
      redirect: "/index",
    },
  ],
  mode: 'history'
});